/** Stored in API `model` so contact vs test drive can be split without a new DB column. */
export const CONTACT_MODEL_PREFIX = "CONTACT_FORM|";

export function encodeContactFormModel(selected) {
  if (!selected || selected === "Contact") return `${CONTACT_MODEL_PREFIX}general`;
  return `${CONTACT_MODEL_PREFIX}${selected}`;
}

export function decodeContactTopic(stored) {
  if (!stored) return "—";
  if (stored.startsWith(CONTACT_MODEL_PREFIX)) {
    const rest = stored.slice(CONTACT_MODEL_PREFIX.length);
    return rest === "general" ? "General contact" : rest;
  }
  if (stored === "Contact") return "General contact (legacy)";
  return stored;
}

export function isContactSubmission(s) {
  const m = s?.model || "";
  return m.startsWith(CONTACT_MODEL_PREFIX) || m === "Contact";
}

export function isTestDriveSubmission(s) {
  return !isContactSubmission(s);
}
